var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BannerStyles, bannerTheme } from './BannerStyles';
import { BannerThemes } from '../../enums';
export var Banner = function (_a) {
    var icon = _a.icon, message = _a.message, iconRight = _a.iconRight, _b = _a.theme, theme = _b === void 0 ? BannerThemes.light : _b, borderLeft = _a.borderLeft;
    var BannerThemeStyles = bannerTheme[theme];
    return (_jsx(BannerStyles, __assign({ theme: theme }, { children: _jsx(BannerThemeStyles, __assign({ borderLeft: borderLeft }, { children: _jsxs("div", __assign({ className: "banner-wrapper" }, { children: [icon && icon, _jsx("div", __assign({ className: "banner-message" }, { children: message })), iconRight && iconRight] })) })) })));
};
